import { Action, Selector, State, StateContext, Store } from '@ngxs/store';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { NotificationService } from '../../../../../../common/services';
import { AllocationViewSealPictureControlModel } from '../../models';
import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  AllocationViewPerformSealPictureControlAction,
  AllocationViewPerformSealPictureControlActionPrepare,
  AllocationViewPerformSealPictureControlActionSetInitialState,
} from './allocation-view-perform-seal-picture-control-action.actions';
import { AllocationViewPerformSealPictureControlActionService } from './allocation-view-perform-seal-picture-control-action.service';
import { AllocationViewActionBaseState } from '../base';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

export interface AllocationViewPerformSealPictureControlActionStateModel {
  loaded: boolean;
  preparedDetails: AllocationViewSealPictureControlModel;
}

const initialState: AllocationViewPerformSealPictureControlActionStateModel = {
  loaded: false,
  preparedDetails: null,
};

@State({
  name: 'allocationViewActionsPerformSealPictureControl',
  defaults: initialState,
})
@Injectable()
export class AllocationViewPerformSealPictureControlActionState extends AllocationViewActionBaseState {
  @Selector()
  static getLoaded(state: AllocationViewPerformSealPictureControlActionStateModel): boolean {
    return state.loaded;
  }

  @Selector()
  static getPreparedDetails(
    state: AllocationViewPerformSealPictureControlActionStateModel,
  ): AllocationViewSealPictureControlModel {
    return state.preparedDetails;
  }

  constructor(
    private allocationViewPerformSealPictureControlActionService: AllocationViewPerformSealPictureControlActionService,
    notificationService: NotificationService,
    store: Store,
  ) {
    super(notificationService, store);
  }

  @Action(AllocationViewPerformSealPictureControlAction)
  sealPictureControlFinished(
    ctx: StateContext<AllocationViewPerformSealPictureControlActionStateModel>,
    { data }: AllocationViewPerformSealPictureControlAction,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.allocationViewPerformSealPictureControlActionService.sealCheck(data).pipe(
      tap(() => {
        this.finishAction('api.uli.success.finishSealPictureControl');
      }),
      catchError(({ error }: HttpErrorResponse) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(AllocationViewPerformSealPictureControlActionPrepare)
  sealPictureControlFinishedPrepare(
    ctx: StateContext<AllocationViewPerformSealPictureControlActionStateModel>,
    { identifier, language }: AllocationViewPerformSealPictureControlActionPrepare,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | AllocationViewSealPictureControlModel> {
    return this.allocationViewPerformSealPictureControlActionService.sealCheckPrepare(identifier, language).pipe(
      tap((response: AllocationViewSealPictureControlModel) => {
        ctx.patchState({
          preparedDetails: response,
          loaded: true,
        });
      }),
      catchError(({ error }: HttpErrorResponse) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(AllocationViewPerformSealPictureControlActionSetInitialState)
  setInitialState(ctx: StateContext<AllocationViewPerformSealPictureControlActionStateModel>): void {
    ctx.setState(initialState);
    this.setContainerAfterActionEffectsInitialState();
  }
}
